
import { formatCurrency } from "@/utils/currency-data";

interface MerchantHeaderProps {
  merchant: string;
  product: string;
  amount: number;
  currency?: string;
}

const MerchantHeader = ({ merchant, product, amount, currency = 'USD' }: MerchantHeaderProps) => {
  // Format the amount with the currency symbol
  const formattedAmount = formatCurrency(amount, currency);
  
  return (
    <div className="flex items-center gap-4">
      <div>
        <h3 className="font-semibold text-lg">{merchant}</h3>
        <p className="text-sm text-muted-foreground">{product}</p>
      </div>
      <div className="bg-slate-100 px-3 py-1.5 rounded-md">
        <span className="font-medium text-slate-900">{formattedAmount}</span>
      </div>
    </div>
  );
};

export default MerchantHeader;
